import React from "react";
import "./styles.scss";

import AssessmentPage from "../../component/assessment";
import { useStateValue } from "../../store/index";

const Assessment = () => {
  const [{ assessmentLanding }, dispatch] = useStateValue();
  return <AssessmentPage data={assessmentLanding} />;
};

export default Assessment;
